type ObjectWithAny = { [key: string]: any };

type FullStory = {
  identify: (id: string, userVars: ObjectWithAny) => void;
  setUserVars: (userVars: ObjectWithAny) => void;
  event: (eventName: string, eventProperties: ObjectWithAny) => void;
};

// Let TypeScript know that the global FS property may exist
declare global {
  interface Window {
    FS?: FullStory;
  }
}

export const getFullStory = (): FullStory => window.FS as FullStory;
